import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'nc-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.less']
})
export class ColorPickerComponent implements OnInit {
  @Input() ncSize: 'small' | 'default' | 'large' = 'default';
  @Input() ncFormat: 'hexa' | 'rgba' = 'hexa';
  @Input() ncValue: string = '#ff0000ff';//#ff0000ff #ff0000 rgba(255,0,0,1) rgb(255,0,0,1) rgb(255,0,0)
  @Output() ncValueChange = new EventEmitter();
  @Output() ncOnchange = new EventEmitter();

  $ncValueChangeSubject = new Subject<any>();
  panelShow: boolean = false;
  //HSV是基于色相H(hue)、饱和度S(saturation)、明度V(Value)
  hsv: any = {
    hue: 360,
    saturation: 100,
    value: 100
  };
  hueColor: any = '255,0,0';//用于颜色面板、色相按钮

  rgb: any = [];
  alpha: number = 1;
  hexa: string = '';
  init: boolean = true;

  constructor(private ele: ElementRef) { }

  ngOnInit(): void {
    this.$ncValueChangeSubject.pipe(
      debounceTime(500),
      distinctUntilChanged((n: string, o: string): boolean => {
        return n === o;
      })
    ).subscribe((_value: any) => {
      //初始时执行两次setNcValue，防抖后执行一次这里
      //由于init为true，初始时不触发ncOnchange而是将init改为false
      //后续执行setNcValue时init为false，触发ncOnchange
      if (!this.init) {
        this.ncOnchange.emit(_value);
      } else {
        this.init = false;
      }
    });
    //根据初始值设置面板
    this.setPanel();
    //绑定点击事件
    this.bindEvent();
  }

  //绑定点击、移动事件
  bindEvent() {
    //色相柱
    this.setHueSlider = this.setHueSlider.bind(this);
    let colorBar: any = this.ele.nativeElement.querySelector('#colorBar');
    let divSlider: any = this.ele.nativeElement.querySelector('#divSlider');
    colorBar.addEventListener('mousedown', (e: any) => {
      this.setHueSlider(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setHueSlider);
    });
    divSlider.addEventListener('mousedown', (e: any) => {
      this.setHueSlider(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setHueSlider);
    });
    this.ele.nativeElement.addEventListener('mouseup', () => {
      this.ele.nativeElement.removeEventListener('mousemove', this.setHueSlider);
    });

    //透明柱状
    this.setAlpha = this.setAlpha.bind(this);
    let alphaBar: any = this.ele.nativeElement.querySelector('#alphaBar');
    let divAlphaSlider: any = this.ele.nativeElement.querySelector('#divAlphaSlider');
    alphaBar.addEventListener('mousedown', (e: any) => {
      this.setAlpha(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setAlpha);
    });
    divAlphaSlider.addEventListener('mousedown', (e: any) => {
      this.setAlpha(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setAlpha);
    });
    this.ele.nativeElement.addEventListener('mouseup', () => {
      this.ele.nativeElement.removeEventListener('mousemove', this.setAlpha);
    });

    //颜色面板
    this.setSaturationAndValue = this.setSaturationAndValue.bind(this);
    let colorPanel: any = this.ele.nativeElement.querySelector('#colorPanel');
    let divPicker: any = this.ele.nativeElement.querySelector('#divPicker');
    colorPanel.addEventListener('mousedown', (e: any) => {
      this.setSaturationAndValue(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setSaturationAndValue);
    });
    divPicker.addEventListener('mousedown', (e: any) => {
      this.setSaturationAndValue(e);
      this.ele.nativeElement.addEventListener('mousemove', this.setSaturationAndValue);
    });
    this.ele.nativeElement.addEventListener('mouseup', () => {
      this.ele.nativeElement.removeEventListener('mousemove', this.setSaturationAndValue);
    });
  }

  //根据默认值初始化面板
  setPanel() {
    if (this.ncValue.charAt(0) == '#') {
      let rgba = this.hexaToRgba(this.ncValue);

      this.rgb = [rgba[0], rgba[1], rgba[2]];
      this.alpha = rgba[3];
    } else {
      let match: any = this.ncValue.match(/^rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)$/);//rgba(255,0,0,1)
      if (!match) {
        match = this.ncValue.match(/^rgb\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)$/);//rgb(255,0,0,1)
      }
      if (!match) {
        match = this.ncValue.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);//rgb(255,0,0)
      }
      let red: any = parseInt(match[1], 10);
      let green: any = parseInt(match[2], 10);
      let blue: any = parseInt(match[3], 10);
      let alpha: any = parseFloat(match[4]);

      this.rgb = [red, green, blue];
      if (Number.isNaN(alpha)) {
        this.alpha = 1;
      } else {
        this.alpha = alpha;
      }
    }

    this.alphaChange();
    this.rgbChange();
  }

  //设置ncValue
  setNcValue() {
    setTimeout(() => {
      if (this.ncFormat == 'hexa') {
        this.ncValue = this.hexa;
      } else {
        this.ncValue = `rgba(${this.rgb[0]},${this.rgb[1]},${this.rgb[2]},${this.alpha})`;
      }
      this.ncValueChange.emit(this.ncValue);//双向绑定
      this.$ncValueChangeSubject.next(this.ncValue);//触发值改变回调
    })
  }

  //触发器点击
  blockClick() {
    let blockDom: any = this.ele.nativeElement.querySelector('.nc-color-picker-block');//触发器
    const clientRect = blockDom.getBoundingClientRect();//触发器位置
    let panelDom: any = this.ele.nativeElement.querySelector('.nc-color-picker-panel');//弹出面板
    //触发器大小
    let blockWidth: number = 0;
    let blockHeight: number = 0;
    if (this.ncSize == 'small') {
      blockWidth = 16;
      blockHeight = 16;
    } else if (this.ncSize == 'large') {
      blockWidth = 32;
      blockHeight = 32;
    } else {
      blockWidth = 24;
      blockHeight = 24;
    }

    let panelHeight: number = 290;//弹出面板高
    let panelWidth: number = 282;//弹出面板宽
    let gap: number = 20;//预留间隙
    let windowHeight: number = window.innerHeight;
    let windowWidth: number = window.innerWidth;

    //清除三角形
    panelDom.classList.remove('topTriangle');
    panelDom.classList.remove('bottomTriangle');
    panelDom.classList.remove('leftTriangle');
    panelDom.classList.remove('rightTriangle');

    if (clientRect.left < (panelWidth / 2 - blockWidth / 2) && clientRect.top < (panelHeight / 2 - blockHeight / 2)) {
      //右下弹出(触发器位于窗口左上角)
      panelDom.style.left = blockWidth + gap / 2 + 'px';
      panelDom.style.top = blockHeight + gap / 2 + 'px';
    } else if (windowWidth - clientRect.right < (panelWidth / 2 - blockWidth / 2) && windowHeight - clientRect.bottom < (panelHeight / 2 - blockHeight / 2)) {
      //左上弹出(触发器位于窗口右下角)
      panelDom.style.right = blockWidth + gap / 2 + 'px';
      panelDom.style.bottom = blockHeight + gap / 2 + 'px';
    } else if (clientRect.left < (panelWidth / 2 - blockWidth / 2) && windowHeight - clientRect.bottom < (panelHeight / 2 - blockHeight / 2)) {
      //右上弹出(触发器位于窗口左下角)
      panelDom.style.left = blockWidth + gap / 2 + 'px';
      panelDom.style.bottom = blockHeight + gap / 2 + 'px';
    } else if (clientRect.top < (panelHeight / 2 - blockHeight / 2) && windowWidth - clientRect.right < (panelWidth / 2 - blockWidth / 2)) {
      //左下弹出(触发器位于窗口右上角)
      panelDom.style.right = blockWidth + gap / 2 + 'px';
      panelDom.style.top = blockHeight + gap / 2 + 'px';
    } else if (clientRect.left >= (panelWidth / 2 - blockWidth / 2) && windowWidth - clientRect.right >= (panelWidth / 2 - blockWidth / 2) && windowHeight - clientRect.bottom >= panelHeight + gap) {
      //下弹出(左右下空间足够)
      panelDom.style.left = -(panelWidth / 2 - blockWidth / 2) + 'px';
      panelDom.style.top = blockHeight + gap + 'px';
      panelDom.classList.add('topTriangle');//添加三角形
    } else if (clientRect.left >= (panelWidth / 2 - blockWidth / 2) && windowWidth - clientRect.right >= (panelWidth / 2 - blockWidth / 2) && clientRect.top >= panelHeight + gap) {
      //上弹出(左右上空间足够)
      panelDom.style.left = -(panelWidth / 2 - blockWidth / 2) + 'px';
      panelDom.style.bottom = blockHeight + gap + 'px';
      panelDom.classList.add('bottomTriangle');//添加三角形
    } else if (clientRect.top >= (panelHeight / 2 - blockHeight / 2) && windowHeight - clientRect.bottom >= (panelHeight / 2 - blockHeight / 2) && windowWidth - clientRect.right >= panelWidth + gap) {
      //右弹出(上下右空间足够)
      panelDom.style.left = blockHeight + gap + 'px';
      panelDom.style.bottom = -(panelHeight / 2 - blockHeight / 2) + 'px';
      panelDom.classList.add('leftTriangle');//添加三角形
    } else if (clientRect.top >= (panelHeight / 2 - blockHeight / 2) && windowHeight - clientRect.bottom >= (panelHeight / 2 - blockHeight / 2) && clientRect.left >= panelWidth + gap) {
      //左弹出(上下左空间足够)
      panelDom.style.right = blockHeight + gap + 'px';
      panelDom.style.bottom = -(panelHeight / 2 - blockHeight / 2) + 'px';
      panelDom.classList.add('rightTriangle');//添加三角形
    }

    setTimeout(() => {
      //加延迟让clickOut先触发
      this.panelShow = true;
    })
  }

  //点击色相柱，计算色相H(hue)
  setHueSlider(event: any) {
    let colorBar: any = this.ele.nativeElement.querySelector('#colorBar');
    let divSlider: any = this.ele.nativeElement.querySelector('#divSlider');
    let colorBarWIDTH: any = colorBar.clientWidth;
    const clientRect = colorBar.getBoundingClientRect();
    // 获取位置信息
    let xDiff = event.clientX - clientRect.left;
    xDiff = xDiff > colorBarWIDTH ? colorBarWIDTH : (xDiff < 0 ? 0 : xDiff);//0-200
    // 设置滑块的位置，保证滑块至少一半在面板内
    divSlider.style.left = xDiff - 6 + 'px';
    // 色相在360度以内，计算对应的比例值， 0 - 360
    this.hsv.hue = Math.round((xDiff / colorBarWIDTH) * 360 * 100) / 100 | 0;

    //转换
    this.rgb = this.hsvToRgb(this.hsv.hue, this.hsv.saturation, this.hsv.value);
    this.hueColor = this.hsvToRgb(this.hsv.hue, 100, 100).join(',');
    this.hexa = this.rgbaToHexa(this.rgb[0], this.rgb[1], this.rgb[2], this.alpha);

    this.setNcValue();
  }

  //点击透明柱，计算透明度
  setAlpha(event: any) {
    let alphaBar: any = this.ele.nativeElement.querySelector('#alphaBar');
    let divAlphaSlider: any = this.ele.nativeElement.querySelector('#divAlphaSlider');
    let alphaBarWIDTH: any = alphaBar.clientWidth;
    const clientRect = alphaBar.getBoundingClientRect();
    // 获取位置信息
    let xDiff = event.clientX - clientRect.left;
    xDiff = xDiff > alphaBarWIDTH ? alphaBarWIDTH : (xDiff < 0 ? 0 : xDiff);//0-200
    // 设置滑块的位置，保证滑块至少一半在面板内
    divAlphaSlider.style.left = xDiff - 6 + 'px';
    //透明度取值在0-1
    this.alpha = (100 - Math.round(100 - xDiff / alphaBarWIDTH * 100)) / 100;

    //转换
    this.hexa = this.rgbaToHexa(this.rgb[0], this.rgb[1], this.rgb[2], this.alpha);

    this.setNcValue();
  }

  //点击颜色面板，计算饱和度S(saturation)、明度V(Value)
  setSaturationAndValue(event: any) {
    let colorPanel: any = this.ele.nativeElement.querySelector('#colorPanel');
    let divPicker: any = this.ele.nativeElement.querySelector('#divPicker');
    let panelWIDTH = colorPanel.clientWidth;
    let panelHEIGHT = colorPanel.clientHeight;

    // 计算鼠标移动位置，面板宽度panelWIDTH，高度panelHEIGHT
    const clientRect = colorPanel.getBoundingClientRect();
    let yDiff = event.clientY - clientRect.top;
    let xDiff = event.clientX - clientRect.left;
    xDiff = xDiff > panelWIDTH ? panelWIDTH : (xDiff < 0 ? 0 : xDiff);
    yDiff = yDiff > panelHEIGHT ? panelHEIGHT : (yDiff < 0 ? 0 : yDiff);

    // 设置滑块位置，保证滑块至少一半在面板内
    divPicker.style.top = yDiff - 8 + 'px';
    divPicker.style.left = xDiff - 8 + 'px';

    // 饱和度和明度，这里没有取百分比的值，后续转换时需要注意
    this.hsv.saturation = Math.round(xDiff / panelWIDTH * 100);
    this.hsv.value = Math.round((1 - yDiff / panelHEIGHT) * 100);

    //转换
    this.rgb = this.hsvToRgb(this.hsv.hue, this.hsv.saturation, this.hsv.value);
    this.hexa = this.rgbaToHexa(this.rgb[0], this.rgb[1], this.rgb[2], this.alpha);

    this.setNcValue();
  }

  //hsv转rgb (h：0-360 s: 0-100 v: 0-100)
  hsvToRgb(hue: number, saturation: number, value: number) {
    saturation = saturation * 255 / 100 | 0
    value = value * 255 / 100 | 0

    if (saturation === 0) {
      return [value, value, value]
    } else {
      let satVal = (255 - saturation) * value / 255 | 0
      let ligVal = (value - satVal) * (hue % 60) / 60 | 0
      if (hue === 360) {
        return [value, satVal + ligVal, satVal]
      } else if (hue < 60) {
        return [value, satVal + ligVal, satVal]
      } else if (hue < 120) {
        return [value - ligVal, value, satVal]
      } else if (hue < 180) {
        return [satVal, value, satVal + ligVal]
      } else if (hue < 240) {
        return [satVal, value - ligVal, value]
      } else if (hue < 300) {
        return [satVal + ligVal, satVal, value]
      } else if (hue < 360) {
        return [value, satVal, value - ligVal]
      } else {
        return [0, 0, 0]
      }
    }
  }

  //rgb转hsv (h：0-100 s: 0-100 v: 0-100)
  rgbToHsv(r: number, g: number, b: number) {
    (r /= 255), (g /= 255), (b /= 255);
    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h: any, s: any, v: any = max;

    let d = max - min;
    s = max === 0 ? 0 : d / max;

    if (max === min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return [Math.round(h * 100), Math.round(s * 100), Math.round(v * 100)];
  }

  //rgba转hexa
  rgbaToHexa(red: any, green: any, blue: any, alpha: any) {
    red = this.getHex(red);
    green = this.getHex(green);
    blue = this.getHex(blue);
    alpha = Math.round(alpha * 255);
    alpha = this.getHex(alpha);
    return '#' + red + green + blue + alpha;
  }
  getHex(num: number) {
    let val = num.toString(16)
    val = (val.length === 1) ? ('0' + val) : val
    return val
  }

  //hex转rgba
  hexaToRgba(color: string) {
    const value = color.slice(color.indexOf('#') + 1);
    const isShort = value.length === 3 || value.length === 4;
    const hasAlpha = value.length === 4 || value.length === 8;
    const r = isShort ? (value.charAt(0) + value.charAt(0)) : value.substring(0, 2);
    const g = isShort ? (value.charAt(1) + value.charAt(1)) : value.substring(2, 4);
    const b = isShort ? (value.charAt(2) + value.charAt(2)) : value.substring(4, 6);
    let a: any = hasAlpha ? (isShort ? (value.charAt(3) + value.charAt(3)) : value.substring(6, 8)) : 'FF';
    a = parseFloat((parseInt(a, 16) / 255).toFixed(2));
    return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), a];
  }

  //输入rgb
  rgbChange() {
    this.hexa = this.rgbaToHexa(this.rgb[0], this.rgb[1], this.rgb[2], this.alpha);
    let hsv = this.rgbToHsv(this.rgb[0], this.rgb[1], this.rgb[2]);//hsv(rgb转,h:0-100)
    //更改this.hsv(选取,h:0-360)值
    //防止接着选取色相时setHueSlider使用默认的saturation和value
    //或选取颜色面板时setSaturationAndValue使用默认的hue
    this.hsv.hue = Math.round(360 * hsv[0] * 0.01);//0-100转0-360
    this.hsv.saturation = hsv[1];
    this.hsv.value = hsv[2];
    this.hueColor = this.hsvToRgb(this.hsv.hue, 100, 100).join(',');

    //调整色相中按钮位置
    let colorBar: any = this.ele.nativeElement.querySelector('#colorBar');
    let divSlider: any = this.ele.nativeElement.querySelector('#divSlider');
    let colorBarWIDTH: any = colorBar.clientWidth;
    divSlider.style.left = colorBarWIDTH * hsv[0] * 0.01 - 6 + 'px';

    //调整颜色面板中按钮位置
    let colorPanel: any = this.ele.nativeElement.querySelector('#colorPanel');
    let divPicker: any = this.ele.nativeElement.querySelector('#divPicker');
    let panelWIDTH = colorPanel.clientWidth;
    let panelHEIGHT = colorPanel.clientHeight;
    divPicker.style.left = panelWIDTH * hsv[1] * 0.01 - 8 + 'px';
    // divPicker.style.bottom = panelHEIGHT * hsv[2] * 0.01 - 8 + 'px';
    divPicker.style.top = panelHEIGHT * (100 - hsv[2]) * 0.01 - 8 + 'px';

    this.setNcValue();
  }

  //输入a
  alphaChange() {
    this.hexa = this.rgbaToHexa(this.rgb[0], this.rgb[1], this.rgb[2], this.alpha);

    //调整透明带中按钮位置
    let alphaBar: any = this.ele.nativeElement.querySelector('#alphaBar');
    let divAlphaSlider: any = this.ele.nativeElement.querySelector('#divAlphaSlider');
    let alphaBarWIDTH: any = alphaBar.clientWidth;
    divAlphaSlider.style.left = alphaBarWIDTH * this.alpha - 6 + 'px';

    this.setNcValue();
  }

  //输入hex
  hexChange() {
    if (this.hexa.charAt(0) != '#') {
      return;
    }
    if (this.hexa.length != 7 && this.hexa.length != 9) {
      return;
    }
    let rgba = this.hexaToRgba(this.hexa);
    this.rgb = [rgba[0], rgba[1], rgba[2]];
    this.alpha = rgba[3];
    this.rgbChange();
    this.alphaChange();
  }

  clickOut() {
    if (this.panelShow) {
      this.panelShow = false;
      this.ele.nativeElement.removeEventListener('mousemove', this.setHueSlider);
      this.ele.nativeElement.removeEventListener('mousemove', this.setAlpha);
      this.ele.nativeElement.removeEventListener('mousemove', this.setSaturationAndValue);
    }
  }
}
